/** mutation types */
const set_error = 'set_error'
const set_hasEncountered401Error = 'set_hasEncountered401Error'

/** state */
const getDefaultState = () => {
  return {
    hasEncountered401Error: false,
    error: {
      message: ''
    }
  }
}
const state = getDefaultState()
/** mutations */
const mutations = {
  [set_error] (state, data) {
    state.error = data
  },
  [set_hasEncountered401Error] (state) {
    state.hasEncountered401Error = true
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  resetErrorState ({ commit }) {
    commit('resetState')
  },
  setError: ({ commit }, data) => {
    commit('set_error', data)
  },
  setHasEncountered401Error: ({ commit }) => {
    commit('set_hasEncountered401Error')
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
